import { Button } from './ui/button'
// @ts-strict-ignore
import { Icon } from '@blueprintjs/core'
import cx from 'classnames'
import React from 'react'
import { KeywordAndTargetBreadcrumbs } from '../columns'
import { AmazonLink, AmazonSearchLink, isAsin } from './amazon_link'
import { SearchTermI } from './SearchTermsTable2'
import { AdGroupName } from './table/AdGroupName'
import { CampaignName } from './table/CampaignName'
import { Toasts } from './toaster/Toast'

interface SearchTermProps {
    searchTerm: SearchTermI
    setSearchTerm: (v: SearchTermI) => void
    extra: {
        screenshotMode: boolean
    }
}

export const SearchTerm = ({
    searchTerm,
    setSearchTerm,
    extra: { screenshotMode },
}: SearchTermProps) => {
    if (searchTerm.type_of === 'search_term') {
        return (
            <div className="flex items-baseline" style={{ lineHeight: '21px' }}>
                <span
                    className={cx('flex', 'items-baseline', {
                        blur: screenshotMode,
                    })}
                >
                    {resolvedSearchTerm(searchTerm)}
                </span>
                <Button
                    minimal
                    small
                    icon={<Icon icon="clipboard" title={'Copy Search Term to Clipboard'} />}
                    className="ml-2"
                    onClick={() => copyToClipboard(searchTerm)}
                />
                <Button
                    minimal
                    small
                    icon={<Icon icon="remove" title="Add Negative Keywords" />}
                    onClick={() => {
                        setSearchTerm(searchTerm)
                    }}
                />
            </div>
        )
    } else if (searchTerm.type_of === 'ad_group') {
        // Use KeywordAndTargetBreadcrumbs which accepts flat properties
        // Works with both Laravel (nested ad_group/campaign) and v5 (flat properties)
        return (
            <div className={'ml-5 flex justify-start'} style={{ lineHeight: '21px' }}>
                <KeywordAndTargetBreadcrumbs
                    className={cx({ blur: screenshotMode })}
                    ad_group={searchTerm?.ad_group}
                    ad_group_id={searchTerm?.ad_group_id}
                    ad_group_name={searchTerm?.ad_group_name}
                    ad_group_status={searchTerm?.ad_group_state}
                    campaign={searchTerm?.ad_group?.campaign}
                    campaign_id={searchTerm?.campaign_id}
                    campaign_name={searchTerm?.campaign_name}
                    campaign_status={searchTerm?.campaign_state}
                    fill
                />
            </div>
        )
    }

    return null
}

const resolvedSearchTerm = (searchTerm: SearchTermI) => {
    const inner = isAsin(searchTerm.search_term) ? (
        <AmazonLink asin={searchTerm.search_term} />
    ) : (
        <AmazonSearchLink query={searchTerm.search_term} />
    )

    return <b>{inner}</b>
}

function copyToClipboard(searchTerm: SearchTermI) {
    let text = searchTerm?.search_term ?? 'undefined'

    if (navigator.clipboard) {
        if (isAsin(searchTerm.search_term)) {
            text = searchTerm.search_term.toUpperCase()
        }

        navigator.clipboard.writeText(text)
        Toasts.success('Search Term copied to clipboard')
    } else {
        Toasts.error('Copying Search Term to clipboard failed')
    }
}
